<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true" class="table">
    <thead>
      <tr class="tr-align-center grey-text">
        <th colspan="4" class="tab-title d-none d-sm-table-cell text-center">{{ 'LABEL.PICKUP_DELIVERY' | translate }}</th>
        <th colspan="3" class="tab-title d-sm-none d-table-cell text-center">{{ 'LABEL.PICKUP_DELIVERY' | translate }}</th>
        <th colspan="3" class="tab-title text-center d-none d-lg-table-cell">{{ 'LABEL.MERCHANDISES' | translate }}</th>
        <th colspan="1" class="tab-title text-center d-table-cell d-lg-none">{{ 'LABEL.MERCHANDISES' | translate }}</th>
        <th colspan="3" class="tab-title text-center">{{ 'LABEL.INFORMATIONS' | translate }}</th>
      </tr>
      <tr jhiSort [(predicate)]="pagination.predicate" [(ascending)]="pagination.reverse" (sortChange)="transition()">
        <th jhiSortBy="id">
          <span class="text-uppercase">{{ 'LABEL.OT' | translate }}</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="companyName" *ngIf="tableOptions && tableOptions.isModerator && !tableOptions.focusForCustomer">
          <span jhiTranslate="LABEL.COMPANY">Customer company name</span>
        </th>
        <th jhiSortBy="pickupReference" *ngIf="!tableOptions || !tableOptions.isModerator">
          <span jhiTranslate="LABEL.REF">Pickup Reference</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th class="text-center">
          <span jhiTranslate="LABEL.PICKUP_DATE">Pickup Date</span><br />
          <span jhiTranslate="LABEL.DELIVERY_DATE">Delivery Date</span>
        </th>
        <th class="d-none d-sm-table-cell">
          <div class="row">
            <span jhiTranslate="LABEL.PICKUP_LOCATION">Pickup Location</span>
          </div>
          <div class="row">
            <span jhiTranslate="LABEL.DELIVERY_LOCATION">Pickup Location</span>
          </div>
        </th>
        <th jhiSortBy="totalUM" class="d-none d-lg-table-cell">
          <span jhiTranslate="LABEL.UM" class="no-capitalize">Total UM</span>
        </th>
        <th jhiSortBy="totalWeight" class="d-none d-lg-table-cell">
          <span jhiTranslate="LABEL.WEIGHT">Total Weight</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="priceHT" class="d-none d-lg-table-cell">
          <span jhiTranslate="LABEL.PRE_TAXES_PRICE" class="no-capitalize">Prix HT</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="deliveryStatus" *ngIf="hasEDI" class="text-center">
          <span jhiTranslate="LABEL.STATUS">Status</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="offerName">
          <span jhiTranslate="LABEL.TYPE_OFFER">Type d'offre</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr mdbTableRow *ngFor="let transportOrder of transportOrders; let i = index">
        <td>
          <span class="text-uppercase table-transport-type-icon d-flex flex-column flex-sm-row" [class]="getTransportTypeIcon(transportOrder)">OT{{ transportOrder.id }}</span>
        </td>
        <td *ngIf="tableOptions && tableOptions.isModerator && !tableOptions.focusForCustomer && transportOrder.customer !== undefined">
          <a class="text-primary" [href]="PATHS.MIDDLE_CUSTOMER_ID_DATA.withId(transportOrder.customer.id)" target="_blank">{{
            transportOrder.companyName ? transportOrder.companyName : 'particulier'
          }}</a>
        </td>
        <td *ngIf="!tableOptions || !tableOptions.isModerator">
          <span>{{ transportOrder.pickupReference }}</span>
        </td>
        <td class="text-center">
          <span>{{ transportOrder.pickupDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
          <br />
          <span *ngIf="!transportOrder.deliveryMaxDate">{{ transportOrder.deliveryDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
          <span *ngIf="transportOrder.deliveryMaxDate">
            {{ 'LABEL.FLEXIBILITY' | translate }}
            <i class="fas fa-circle-info ml-1" [mdbTooltip]="getTooltipFlexibility(transportOrder)"></i
          ></span>
        </td>
        <td class="d-none d-sm-table-cell">
          <div class="row">
            <span class="no-capitalize"
              >{{ transportOrder.pickupAddressCity ? transportOrder.pickupAddressCity : '' }} , {{ transportOrder.pickupAddressCountry | countryName }}</span
            >
          </div>
          <div class="row">
            <span class="no-capitalize"
              >{{ transportOrder.deliveryAddressCity ? transportOrder.deliveryAddressCity : '' }} , {{ transportOrder.deliveryAddressCountry | countryName }}</span
            >
          </div>
        </td>
        <td class="d-none d-lg-table-cell">
          <span [mdbTooltip]="getTotalUMTooltip(transportOrder)">{{
            (transportOrder.totalPallets || 0) + (transportOrder.totalParcel || 0) + (transportOrder.totalOtherUM || 0)
          }}</span>
        </td>
        <td class="d-none d-lg-table-cell">
          <span>{{ transportOrder.totalWeight }} kg</span>
        </td>
        <td class="d-none d-lg-table-cell">
          <span>{{ transportOrder.priceHT }} €</span>
          <i
            *ngIf="
              transportOrder.refundedStatus?.code === LIST_REFUNDED_STATUS.TOTALLY_REFUNDED || transportOrder.refundedStatus?.code === LIST_REFUNDED_STATUS.PARTIALLY_REFUNDED.code
            "
            class="pl-1 fas fa-exchange-alt"
            [class.text-danger]="transportOrder.refundedStatus?.code === LIST_REFUNDED_STATUS.TOTALLY_REFUNDED.code"
            [class.text-warning]="transportOrder.refundedStatus?.code === LIST_REFUNDED_STATUS.PARTIALLY_REFUNDED.code"
            [mdbTooltip]="transportOrder.refundedStatus?.translationKey! | translate"
          ></i>
        </td>
        <td *ngIf="hasEDI" class="text-center">
          <jhi-bary-badge [options]="transportOrder.statusBadgeOpts()"></jhi-bary-badge>
        </td>
        <td>
          {{ transportOrder.offerName }}
        </td>
        <td class="text-right">
          <jhi-bary-cta *ngIf="transportOrder" [actions]="transportOrder.ctaActions" (selectAction)="onSelectAction($event, transportOrder)"></jhi-bary-cta>
        </td>
      </tr>
      <tr [hidden]="transportOrders && transportOrders.length > 0">
        <td colspan="15" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5">{{ 'TRANSPORTS_LIST.NO_TRANSPORT' | translate }}</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
